var BusinessJoin = (function () {

    return {
        openTeamStep: openTeamStep,
    }

    function openTeamStep() {
        var $userStep = $("#userStep");
        var $teamStep = $("#teamStep");

        //스크롤 내려가는 이슈 있어서 top으로 고정
        $(document).scrollTop(0);

        $userStep.fadeOut(0);
        $teamStep.fadeIn(200);
        $teamStep.find("input").off("keyup").on("keyup", CommonJoin.keyupJoinInput);
        $teamStep.find("#joinTeamSector").on("change", CommonJoin.changeTeamSector);
        $teamStep.find("#domain").text("." + location.host.replace("www.", ""));
        GoogleTagManager.collect({"event": Often.isGlobal()? "signup4" : "signUp1"});
        if(!Often.isGlobal()) GoogleTagManager.collect({
            event: "ga4_signup4",
            userId: $.trim($("#joinUserEmail").val()),
        });
        $("#movePrevStepButton").off("click").on("click", movePrevStepPage);
        $("#moveNextStepButton").off("click").on("click", (e) => CommonJoin.moveFinalStepButton(e));
        //Testing.fillTeamStepValue();

        // 예상 가입 인원
        const HopeUserSelector = requireModule("HopeUserSelector", { on : ["main"]})();
        if(HopeUserSelector) {
            HopeUserSelector?.showHopeUserCountSelector($("#joinTeamHopeUserCountSelector"), "LABEL");
        }

        function movePrevStepPage() {
            $teamStep.find("#joinTeamName").val("");
            $teamStep.find("#joinTeamUrl").val("");
            $teamStep.find("joinTeamSector").val("");

            $userStep.fadeIn(200);
            $teamStep.fadeOut(0);
        }
    }
})();
